module.exports = __webpack_public_path__ + "img/r4.1709f410.jpg";